import { render } from "./index.vue?vue&type=template&id=9e8d7878&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9e8d7878&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9e8d7878"

export default script